import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToDays'
})
export class SecondsToDaysPipe implements PipeTransform {

  transform(value: number): number {
    if (value == null || isNaN(value)) {
      return 0;
    }
    
    // Convertir segundos a días (1 día = 86400 segundos) y redondear hacia abajo
    return Math.floor(value / 86400);
  }
}
